export default "__VITE_ASSET__B_I7MnNM__"